import React__default from 'react';
import classNames from 'classnames';
import Styles from './BidAmount.module.scss.js';
import { ExpectedAmountType, ExpectedAmountTypeNameMapping } from '../../constants/payment.js';

const BidAmount = ({ amount, amountType, bidderId, id }) => {
    if (!amount)
        return React__default.createElement(React__default.Fragment, null);
    return (React__default.createElement("div", { className: Styles.main },
        React__default.createElement("h3", { className: Styles.amount, id: id ? `${id}--price` : "", "data-price": amount },
            "\u20B9 ",
            amount.toLocaleString("en-IN")),
        React__default.createElement("p", { className: classNames(Styles.exptdAmountPymtType, Styles.desktop) },
            React__default.createElement("span", { className: Styles.expectedPrice },
                bidderId ? ("Bid Amount ") : (React__default.createElement(React__default.Fragment, null,
                    "Expected ",
                    React__default.createElement("span", { className: Styles.price }, " Price "))),
                "(",
                amountType === ExpectedAmountType.FIXED_PRICE
                    ? ExpectedAmountTypeNameMapping.FIXED_PRICE
                    : ExpectedAmountTypeNameMapping.PER_TONNE,
                ")"))));
};

export { BidAmount as default };
//# sourceMappingURL=BidAmount.js.map
